import { render, staticRenderFns } from "./Cckctj.vue?vue&type=template&id=506d2967&scoped=true&"
import script from "./Cckctj.vue?vue&type=script&lang=js&"
export * from "./Cckctj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506d2967",
  null
  
)

export default component.exports